import { Expose, Type } from "class-transformer";
import { IsBoolean, IsNumber, IsString } from "class-validator";
import { KpContractor } from "@/models/api/Contractor";

export class CreateDocumentResponse {
  @Expose()
  @IsString()
  documentNumber!: string; // "PA 23/2022"
  @Expose()
  @IsString()
  documentId!: string;
  @Expose()
  @IsNumber()
  grossInCurrency!: number; // 5
  @Expose()
  @IsString()
  issueDate!: string; // "2022-04-11T00:00:00"
  @Expose()
  @IsBoolean()
  generateKP!: boolean;
  @Expose()
  @Type(() => KpContractor)
  contractor!: KpContractor;
}
